module.exports = __webpack_public_path__ + "img/guanhzu.fc2a3e04.png";